module.exports = __webpack_public_path__ + "app/directives/wmcanvas.view.html";